import React, { useState, useEffect } from 'react';

import { optionPropType } from '@vlabs/shared/types/propTypes';
import validate from '@vlabs/shared/validators';
import PropTypes from 'prop-types';
import { useWatch, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { addOption, removeOption, normalizeGroupedOptions } from '../helpers';
import { useFilterCount } from '../hooks/useFilterCount';

export const HandlersSelectPopover = ({ handlerOptions, onCountChange = undefined, ...props }) => {
  const { t } = useTranslation();
  const [allOptions, setAllOptions] = useState(handlerOptions);
  const [createdOptions, setCreatedOptions] = useState([]);
  const selectedHandlerIds = useWatch({ name: 'handler_ids' }) || [];
  const { control } = useFormContext();

  useEffect(() => {
    // при инициализации смотрим есть ли в форме уже добавленные опции
    const initialCreated = handlerOptions.filter(
      (option) => !handlerOptions.some((c) => c.value === option.value),
    );
    setCreatedOptions(normalizeGroupedOptions(initialCreated));
  }, []);

  useEffect(() => {
    const grouped = normalizeGroupedOptions(handlerOptions);
    setAllOptions([...createdOptions, ...grouped]);
  }, [createdOptions, handlerOptions]);

  const filterCount = Array.isArray(selectedHandlerIds) && selectedHandlerIds.length > 0 ? 1 : 0;
  useFilterCount('handlers', filterCount, onCountChange);

  const onCreateOption = (option) => {
    setCreatedOptions((prev) => addOption({
      createdOptions: prev,
      newOption: option,
    }),
    );
  };

  const onDeleteOption = (option) => {
    setCreatedOptions((prev) => removeOption({
      createdOptions: prev,
      newOption: option,
    }),
    );
  };

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="handlersFilter"
      triggerValue={t('handling_policies')}
      {...props}
    >
      <CheckboxCustomFilter
        control={control}
        createdOptions={createdOptions}
        isCreatable
        isMulti
        isSearchable
        name="handler_ids"
        onCreateOption={onCreateOption}
        onDeleteOption={onDeleteOption}
        options={allOptions}
        validateProp={validate.uuid()}
      />
    </CustomFilterPopover>
  );
};

HandlersSelectPopover.propTypes = {
  handlerOptions: PropTypes.arrayOf(optionPropType).isRequired,
  onCountChange: PropTypes.func,
};
